export enum Queries {
    getKpiScoreMetadata = 'getKpiScoreMetadata',
}
